import { actionCopyEnUs } from "./actionCopy";

export const inviteCopyEnUs = {
    reviewSetup: "Review setup",
    organisationAndContact: "Organization and contact",
    addPatient: "Add patient",
    inviteByEmail: "Invite by email",
    shareQrCode: "Share link / QR code",
    inviteSent: "Invite sent",
    inviteSentTo: (email) => `Invite sent to ${email}`,
    loading: actionCopyEnUs.loading,
    justAMoment: "Just a moment...",
    patientEmailWillReceiveInstructions: (email) => `${email} will receive an email with instructions to get started.`,
    patientPhoneWillReceiveInstructions: (phone) =>
        `${phone} will receive a text message with instructions to get started.`,
    patientWillReceiveInstructions: "Your patient will receive an email with instructions to get started.",
    emailAndMobileHint: "Both if you can.",
    emailOrPhoneRequired: "(or phone required)",
    mobileOrEmailRequired: "(or email required)",
    diariesAddedInLast7Days: (count) => `In the last 7 days, you have added ${count} diaries to Patient Watch.`,
    goToDiary: "Go to diary",
    inviteAnotherPatient: "Invite another patient",
    whatWasInjected: "What was injected",
    clinicians: "Clinicians",
    referringClinician: "Referring clinician",
    injectingClinician: "Injecting clinician",
    operatingSurgeon: "Operating surgeon",
    therapist: "Therapist",
    injectionMethod: "Injection method",
    questionnaires: "Questionnaires",
    clinicContact: "Clinic contact",
    surgeryDetails: "Surgery details",
    injectionDetails: "Injection details",
    treatmentDetails: "Treatment details",
    consultationDetails: "Consultation details",
    consultationName: "Consultation name",
    description: "Description",
    clinician: "Clinician",
    consultingClinician: "Consulting clinician",
    consultingClinicianDescription: "The clinician who provided the consultation",
    productDetails: "Product details",
    providingClinician: "Providing clinician",
    providingClinicianDescription: "The clinician who prescribed, supplied, or set up the product",
    usageInstructions: "Usage instructions",
    editInjectionDetails: "Edit injection details",
    editInjectionClinicians: "Edit injection clinicians",
    editSurgeryDetails: "Edit surgery details",
    editSurgeryClinicians: "Edit surgery clinicians",
    editShockwaveDetails: "Edit shockwave details",
    editShockwaveClinicians: "Edit shockwave clinicians",
    editConsultationDetails: "Edit consultation details",
    editConsultingClinician: "Edit consulting clinician",
    editProductDetails: "Edit product details",
    editProvidingClinician: "Edit providing clinician",
    editClinicContact: "Edit clinic contact",
    notSet: "Not set",
    selected: "Selected",
    unknownForm: "Unknown form",
    unknownSchedule: "Unknown schedule",
    noSide: "No side",
    email: "Email",
    enterEmail: "Enter email",
    titleOptional: "Title (optional)",
    firstNameOptional: "First name (optional)",
    lastNameOptional: "Last name (optional)",
    mobileNumber: "Mobile",
    firstNamePlaceholder: "e.g. Sherlock",
    lastNamePlaceholder: "e.g. Holmes",
    selectPlaceholder: "Select",
    sendInvite: "Send invite",
    sendingInvite: "Sending invite…",
    inviteSentToast: "Invite sent",
    existingPatient: "Existing patient",
    existingPatientAddDiary: "We'll add this diary to their existing account.",
    existingUser: "Existing user",
    existingUserAddToOrganisation: "We'll add them to this organization instead of creating a new account.",
    existingSecretary: "Existing secretary",
    existingSecretaryAddAsYours: "We'll add them as your secretary for this organization.",
    diaryQuotaBlockedTitle: "Diary limit reached",
    diaryQuotaUsage: (used: number, limit: number) => `You've used ${used} of ${limit} diaries this billing period.`,
    diaryQuotaBlockedDescription: "Upgrade your plan to invite more patients with diaries.",
    diaryQuotaUpgradeCta: "Choose a plan",
    diaryQuotaOwnerUnresolved:
        "We could not work out which clinician's diary allowance applies. Link this secretary to one clinician, or invite while signed in as that clinician.",
    noTemplateSelected: "No template selected. Please",
    createTemplate: "create a template",
    createTemplateFirst: "first.",
    organisation: "Organization",
    hospitalNumberOptional: "Hospital number (optional)",
    enterNhsHospitalNumber: "Enter NHS hospital number",
    hospitalNumberDescription: "Helps match this patient in your hospital records.",
    referenceDateLabel: "Date follow-ups count from",
    referenceDateStartToday: "Start today",
    referenceDateAskPatient: "Patient tells us",
    referenceDateStartTodayHint: "Questionnaires start today. The patient is not asked for a date.",
    referenceDateAskPatientHint: "The patient gives the date when they set up their diary.",
    selectOrganisationToContinue: "Select an organization to continue.",
    selectContactToContinue: "Select a contact person to continue.",
    doctorEmailSharedWithPatient: "This email is shared with the patient, so be careful sharing it or using it here.",
    enterPhoneNumber: "Enter phone number",
    backToSetup: "Back to setup",
    patientInvite: "Patient invite",
    diaryQrCode: "Diary QR code",
    diaryQrDescription:
        "Share this QR code or link so patients can sign up on their phone and start this diary. Setup details were confirmed on the previous step.",
    generatingInviteLink: "Generating invite link…",
    failedToCreateInviteLink: "Failed to create invite link",
    hospitalOnTheInvite: "Hospital on the invite",
    changingOrganisationUpdatesLink: "Changing this updates the link and QR code.",
    shownOnPatientSignupLink: "Shown on the patient sign-up link.",
    patientWillChooseOrganisation: "This means the patient will choose their organization at sign-up.",
    hospitalNumber: "Hospital Number",
    enterHospitalNumber: "Enter hospital number",
    requiredForNhsOrganisations: "Shown for organizations that collect a hospital number",
    copyLink: "Copy link",
    copyQrCode: "Copy QR code",
    copyInviteLink: "Copy invite link",
    invitePageTitle: "Invite",
    roleAndOrganisation: "Role and organization",
    navInviteDescription: "Invite a clinician, patient or secretary to Patient Watch.",
    tabEmail: "Email",
    tabQrCode: "QR Code",
    optionalSuffix: "(optional)",
};
